import { FormExtractorService } from '../../../shared/services/form-extractor.service';
import { LogService } from '../../../shared/services/log.service';
import { Validator } from '../../../shared/services/validator';
import { CTRL_NAME_EXTRACTOR } from '../ctrl.name.extractor';

export class CTRL_499 implements Validator {

    public static id = 'CTRL_499';
    private message = 'error.ctr_499';


    public LOG: LogService = new LogService(CTRL_499);
    public formExtractorService: FormExtractorService = new FormExtractorService();

    
    validate(form: any, map) {

        
        // vérifier si la règle est applicable sur mon formulaire
        const rgs: string[] = CTRL_NAME_EXTRACTOR.getCtrlNames(form, CTRL_499.id + '_');

        if (rgs.length > 0) {
            for (const rg of rgs) {
                const ctrl = form.controls[rg];
                const objetPrinCp = ctrl.value.rgCtrls.objetPrinCp;
                const objetPrinCs = ctrl.value.rgCtrls.objetPrinCs;
                const objetCompCp = ctrl.value.rgCtrls.objetCompCp;
                const objetCompCs = ctrl.value.rgCtrls.objetCompCs;
                const controls = this.formExtractorService.getMapControlsIdWithoutStepAndValue(form);
                const controlsNameCpv = [];
                const objetComplementaireIters = this.formExtractorService.getIndexes(Array.from(controls.keys()), ['_SepSep_TypeCPVClass_SepAtt_classPrincipale'], objetCompCp.split('INDEX')[0]);
                controlsNameCpv.push(objetPrinCp);
                controlsNameCpv.push(objetPrinCs);
                for (let i = 1; i <= objetComplementaireIters.size; i++) {
                    controlsNameCpv.push(objetCompCp.replace('INDEX_499_1', i));
                    controlsNameCpv.push(objetCompCs.replace('INDEX_499_1', i));
                }
                const valuesCpv = [];
                for (let i = 0; i < controlsNameCpv.length; i++) {
                    if (Array.isArray(form.controls[map.get(controlsNameCpv[i])].value)) {
                        form.controls[map.get(controlsNameCpv[i])].value.forEach(function(item){
                            if (item !== '' && item != null) {
                                valuesCpv.push(item);
                            }
                         });
                     } else {
                        if (form.controls[map.get(controlsNameCpv[i])].value !== '' && form.controls[map.get(controlsNameCpv[i])].value != null) {
                            valuesCpv.push(form.controls[map.get(controlsNameCpv[i])].value);
                        }
                    }
                }
                if (valuesCpv.filter((item, i, ar) => ar.indexOf(item) === i).length === valuesCpv.length) {
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: false };
                } else {
                    // placer le message d'erreur
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: true, validation_message: this.message };
                }
            }
        }
    }
}
